import styled from 'styled-components';

export const PlanWrapper = styled.div<{ selected: boolean; disabled?: boolean }>`
  s-box {
    border-width: 2px;
  }
  ${({ disabled }) => !disabled && 'cursor: pointer;'}
  ${({ selected, disabled }) =>
    selected &&
    !disabled &&
    `
    s-box {
      border: 2px var(--color-interaction-border-focus) solid;
      box-shadow: 0px 4px 4px rgb(var(--shadow-color-rgb) / 25%);
    }
  `}
`;

export const FixedWidthPlanWrapper = styled(PlanWrapper)`
  width: 260px;
`;
